import styled from 'styled-components'
import { Checkbox } from 'antd'

export const OptionCheckbox = styled(Checkbox)`
  width: 80%;
`
